import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ProductService } from "../../../pages/product/product.service";
import { PageResult } from "../../model/page-result";
import { Columns } from "../../util/column-builder.util";
import { DynamicDataGridComponent } from "../dynamic-data-grid/dynamic-data-grid.component";

@Component({
  selector: 'ngx-side-product-search',
  templateUrl: './side-product-search.component.html',
  styleUrls: ['./side-product-search.component.scss']
})
export class SideProductSearchComponent implements OnInit {
  @ViewChild('dg', { static: false }) grid: DynamicDataGridComponent;

  public value: string = '';
  public condition: string = 'ALL';
  public searchedValue: string = '';
  public searchedCondition: string = 'ALL';

  @Input('loading') isLoading: boolean = false;
  @Input('products') products: PageResult<any> = new PageResult<any>();
  public drawerHeight = 250;
  private maxHeight = 0;
  private resizing = false;
  private startY = 0;
  private startHeight = 0;
  public minHeight = 200;
  private ticking = false;

  @Output() pageChange = new EventEmitter<any>();
  @Output() searched = new EventEmitter<any>();
  @Output() clicked = new EventEmitter<any>();

  public columns = Columns.builder()
    .addNumeric('productCode', '코드').set('productCode', 'maxWidth', '90')
    .add('productName', '제품명').set('productName', 'cellClass', 'text-left')
    .add('publisherName', '저작권사').set('publisherName', 'cellClass', 'text-left')
    .add('osTypeAsString', 'OS종류').set('osTypeAsString', 'maxWidth', '100')
    .add('licenseTypeAsString', '라이선스').set('licenseTypeAsString', 'maxWidth', '100')
    .build();

  constructor() {}

  ngOnInit(): void {
    const cardElement = document.querySelector('.card-with-drawer') as HTMLElement;
    this.maxHeight = cardElement.clientHeight - 20;
  }

  onSearch() {
    this.searchedCondition = this.condition;
    this.searchedValue = this.value;
    this.searched.emit({value: this.searchedValue, condition: this.searchedCondition, isPageChange: false});
  }

  onChangePage() {
    this.pageChange.emit({value: this.searchedValue, condition: this.searchedCondition, isPageChange: false});
  }

  onRowClick(event: any) {
    this.clicked.emit(event);
  }

  startResize(event: MouseEvent) {
    this.resizing = true;
    this.startY = event.clientY;
    this.startHeight = this.drawerHeight;
    event.preventDefault();
  }

  @HostListener('document:mouseup', ['$event'])
  stopResize(event: MouseEvent) {
    if (this.resizing) {
      this.resizing = false;
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (!this.resizing) return;

    const dy = this.startY - event.clientY;
    const cardElement = document.querySelector('.card-with-drawer') as HTMLElement;
    this.maxHeight = cardElement.clientHeight - 20;
    const changedHeight = Math.min(this.maxHeight, Math.max(this.minHeight, this.startHeight + dy));

    if (!this.ticking) {
      this.ticking = true;
      requestAnimationFrame(() => {
        this.drawerHeight = changedHeight;
        this.ticking = false;
      });
    }
  }

}

